export const APP_URL = process.env.NEXT_PUBLIC_APP_URL;
export const GRAPHQL_URL = process.env.NEXT_PUBLIC_GRAPHQL_URL;
export const GRAPHQL_LOCAL_URL = process.env.NEXT_PUBLIC_GRAPHQL_LOCAL_URL;
export const SERVER_URL = process.env.NEXT_PUBLIC_BACKEND_URL;
